export default function (context) {
  context.app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    // this should probably be changed automatically but it's not happening when changing the locale from nuxt i18n, so changing it here so next time the user reloads it opens the right page
    context.app.$cookies.set('i18n_redirected', newLocale)
  }
}
